import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { CURRENT_YEAR_PREFIX, HP_COMPETITOR_ID, PREV_YEAR_PREFIX } from '../constants'

import { getAllFoundDescendants } from './getAllFoundDescendants'
import { getFieldsWithCurrencyAndValueType } from './getFieldsWithCurrencyAndValueType'
import { isSobField } from './isSobField'

interface IGetUpdatedUpdatedChildrenData {
  competitors: ISobCompetitor[]
  competitorId: string
  entryId: string
  field: string
  observedFields: string[]
}

export const getUpdatedChildrenData = ({
  competitors,
  competitorId,
  entryId,
  field,
  observedFields,
}: IGetUpdatedUpdatedChildrenData) => {
  const prefix = field.startsWith(CURRENT_YEAR_PREFIX) ? CURRENT_YEAR_PREFIX : PREV_YEAR_PREFIX
  const fields = observedFields.filter((field) => field.startsWith(prefix))
  const item = competitors.find((el) => el.CompetitorID === competitorId && el.EntryId === entryId)

  if (!item) {
    return []
  }

  if (item.CompetitorID === HP_COMPETITOR_ID) {
    return competitors
  }

  const allDescendants = getAllFoundDescendants({ competitors, parentId: entryId, competitorId })
  return competitors.map((comp) => {
    const found = allDescendants.find(
      (el) => el.EntryId === comp.EntryId && el.CompetitorID === comp.CompetitorID
    )
    if (found) {
      const zeroFields = fields
        .reduce((acc: string[], field) => {
          if (isSobField(field)) {
            return [...acc, field]
          }
          return [...acc, ...getFieldsWithCurrencyAndValueType(field)]
        }, [])
        .reduce((acc, field) => {
          return { ...acc, [field]: 0 }
        }, {})
      return { ...found, ...zeroFields }
    }
    return comp
  })
}
